export const EXTERNAL_DOMAIN_STATUS = {
  PENDING_DNS: "pending_dns",
  DNS_VERIFIED: "dns_verified",
  CERT_PENDING: "cert_pending",
  PARKED: "parked",
  ACTIVE: "active",
  FAILED: "failed",
};

export const EXTERNAL_DOMAINS_TABLE_HEADERS = [
  { label: "Domain", key: "domain", width: 5 },
  { label: "Status", key: "status_label", width: 3 },
  { label: "Bound to app", key: "bound_app_label", width: 4 },
  { label: "Added on", key: "added_on_label", width: 3 },
  { label: "", key: "row_actions", width: 1 },
];

export const TRANSIENT_STATUSES = [
  EXTERNAL_DOMAIN_STATUS.PENDING_DNS,
  EXTERNAL_DOMAIN_STATUS.DNS_VERIFIED,
  EXTERNAL_DOMAIN_STATUS.CERT_PENDING,
];

export const STATUS_BADGE_CONFIG = {
  [EXTERNAL_DOMAIN_STATUS.PENDING_DNS]: {
    label: "Waiting for DNS",
    tone: "warning",
  },
  [EXTERNAL_DOMAIN_STATUS.DNS_VERIFIED]: {
    label: "DNS verified",
    tone: "warning",
  },
  [EXTERNAL_DOMAIN_STATUS.CERT_PENDING]: {
    label: "Issuing certificate",
    tone: "warning",
  },
  [EXTERNAL_DOMAIN_STATUS.PARKED]: {
    label: "Ready",
    tone: "neutral",
  },
  [EXTERNAL_DOMAIN_STATUS.ACTIVE]: {
    label: "Active",
    tone: "success",
  },
  [EXTERNAL_DOMAIN_STATUS.FAILED]: {
    label: "Failed",
    tone: "danger",
  },
};

export const PROVISIONING_STEPS = [
  { key: EXTERNAL_DOMAIN_STATUS.PENDING_DNS, label: "Waiting for DNS" },
  { key: EXTERNAL_DOMAIN_STATUS.DNS_VERIFIED, label: "DNS verified" },
  { key: EXTERNAL_DOMAIN_STATUS.CERT_PENDING, label: "Issuing certificate" },
  { key: EXTERNAL_DOMAIN_STATUS.PARKED, label: "Ready" },
];

export const POLL_INTERVAL_MS = 20000;
export const LIST_REFRESH_INTERVAL_MS = 30000;
export const STALE_DNS_MS = 10 * 60 * 1000;

export const EXTERNAL_DOMAINS_COPY = {
  PAGE_TITLE: "External Domains",
  CONNECT_BUTTON: "Connect Domain",
  EMPTY_TITLE: "No external domains yet",
  EMPTY_SUBTITLE:
    "Connect a domain to serve your vibe-coded apps under your own URL.",
  MODAL_TITLE: "Connect Domain",
  MODAL_TITLE_VIEW: "Domain details",
  VIEW_DETAILS: "View details",
  DOMAIN_LABEL: "Domain",
  DOMAIN_PLACEHOLDER: "e.g. theirco.com or app.theirco.com",
  DOMAIN_HELP:
    "Apex or subdomain — we'll walk you through the DNS setup next.",
  DOMAIN_INVALID: "Please enter a valid domain.",
  DNS_PANEL_TITLE: "Add these A records at your DNS provider",
  DNS_PANEL_SUBTITLE:
    "DNS propagation can take 2–15 minutes. You can close this window — provisioning keeps running.",
  STALE_DNS_HINT:
    "Still waiting. Make sure you've added the A records above — changes can take a few minutes to propagate.",
  FAILED_FALLBACK:
    "We couldn't provision this domain. Please double-check your A records and try again.",
  DELETE_TITLE: "Delete domain",
  DELETE_WARNING:
    "This tears down the certificate and DNS verification. You'll need to redo setup to use this domain again.",
  DELETE_WHILE_BOUND_TITLE: "Detach and delete",
  DELETE_WHILE_BOUND_WARNING:
    "This domain is currently attached to an app. It will be detached first and then permanently deleted. The certificate will be destroyed.",
  DELETE_CONFIRM: "Delete",
  DOMAIN_TAKEN: "This domain is already registered in your workspace.",
  GENERIC_ERROR: "Something went wrong. Please try again.",
};
